export default __webpack_public_path__ + "26a4dbc05524c2369765489ea25c685c.png";